import {
  databaseLimitMessageKey,
  decodeDatabaseLimitMessage,
} from '@streamlain/database-identity';
import {
  decodeCellValueError,
  decodeNumberInputError,
  RUNNER_LOST_ERROR,
} from '@streamlain/field-types';

type Translate = Record<string, (values: Record<string, string>) => string>;

/**
 * Localizes workflow errors whose message carries a stable payload; returns
 * null for every other error so callers keep their existing handling.
 */
export function formatWorkflowErrorMessage(
  t: unknown,
  message: string
): string | null {
  const translate = t as Translate;
  const numberInput = decodeNumberInputError(message);
  if (numberInput) {
    return translate['com.streamlain.automation.number-input.error']({
      field: numberInput.fieldName,
      row: numberInput.rowId,
      example: numberInput.decimalComma ? '1.234,56' : '1,234.56',
    });
  }
  const cellValue = decodeCellValueError(message);
  if (cellValue) {
    return translate[
      `com.streamlain.automation.cell-value.error.${cellValue.columnType}`
    ]({ column: cellValue.columnName });
  }
  if (message.includes(RUNNER_LOST_ERROR)) {
    return translate['com.streamlain.automation.run.error.runner-lost']({});
  }
  const databaseLimit = decodeDatabaseLimitMessage(message);
  if (databaseLimit) {
    return translate[
      `com.streamlain.dataview.database.limit.${databaseLimitMessageKey(databaseLimit)}`
    ]({ limit: new Intl.NumberFormat().format(databaseLimit.limit) });
  }
  return null;
}
